import { Ship, ExternalLink, CheckCircle, Sailboat } from "lucide-react";
import { useState } from "react";
import VesselReference from "../../components/Admin/Reference/VesselOverview/VesselReference";
import FleetReference from "../../components/Admin/Reference/FleetOverview/FleetReference";
import ComplianceReference from "../../components/Admin/Reference/Compliance/ComplianceReference";

// Main tabs configuration
const mainTabs = [
  {
    id: "fleet",
    label: "Fleet Overview",
    icon: Sailboat,
  },
  {
    id: "vessel",
    label: "Vessel Overview",
    icon: Ship,
  },
  {
    id: "compliance",
    label: "Compliance",
    icon: CheckCircle,
  },
];

const ReferencePage = () => {
  const [activeTab, setActiveTab] = useState("fleet");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  // Active tab gradient styles
  const activeTabStyle = {
    background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    boxShadow: "0 4px 15px rgba(37, 99, 235, 0.2)",
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-blue-50 rounded-lg">
            <ExternalLink className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Reference</h1>
            <p className="text-gray-600 text-sm">Manage fleet, vessel, and compliance data</p>
          </div>
        </div>

        {/* Enhanced Main Tabs Navigation */}
        <div className="flex justify-center mb-4">
          <div className="w-full max-w-3xl bg-white rounded-xl shadow-sm border border-gray-200 p-2">
            <div className="flex justify-center">
              {mainTabs.map((tab) => {
                const isActive = activeTab === tab.id;
                const Icon = tab.icon;
                
                return (
                  <button
                    key={tab.id}
                    className={`flex items-center justify-center px-8 py-4 rounded-lg text-md font-semibold transition-all duration-300 relative group mx-1 flex-1 max-w-xs ${
                      isActive
                        ? "text-white"
                        : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                    }`}
                    style={isActive ? activeTabStyle : {}}
                    onClick={() => handleTabClick(tab.id)}
                  >
                    {/* Hover effect for inactive tabs */}
                    {!isActive && (
                      <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-gray-400 to-gray-600 opacity-0 group-hover:opacity-5 transition-opacity duration-300"></span>
                    )}

                    <span className="relative z-10 flex items-center gap-3">
                      <Icon className="w-5 h-5" />
                      {tab.label}
                    </span>

                    {/* Active indicator bar */}
                    {isActive && (
                      <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-white rounded-full"></span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="max-w-7xl mx-auto">
          {activeTab === "fleet" && <FleetReference />}
          {activeTab === "vessel" && <VesselReference />}
          {activeTab === "compliance" && <ComplianceReference />}
        </div>
      </div>
    </div>
  );
};

export default ReferencePage;